import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
import { useSurfaceColorAtElevation } from '../Surface';
const LinearProgressIndicator = (props) => {
    const theme = useTheme();
    return (_jsx("div", { css: {
            position: 'relative',
            backgroundColor: useSurfaceColorAtElevation(x => x + 1),
            height: 6,
            borderRadius: 3,
            overflow: 'hidden',
        }, children: _jsx("div", { css: {
                position: 'absolute',
                inset: 0,
                backgroundColor: props.value > (props.optimum ?? 0)
                    ? '#38D448'
                    : props.value > (props.least ?? 0)
                        ? '#F48F45'
                        : theme.color.error,
                height: 6,
                transition: 'ease 1s',
                transform: `scaleX(${props.value})`,
                transformOrigin: 'left',
            } }) }));
};
export default LinearProgressIndicator;
//# sourceMappingURL=LinearProgressIndicator.js.map